import { render } from "./gallery-item.html?vue&type=template&id=26a83707"
import script from "./GalleryItem.vue?vue&type=script&lang=ts"
export * from "./GalleryItem.vue?vue&type=script&lang=ts"

import "./gallery-item.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script